export default __webpack_public_path__ + "static/img/5.69e1555.png";